import { ErrorLoadingPage, Loading } from '@hapvida/hapvida-core-components';

import { GroupedServices, FilteredServices } from './components';
import { useMovementMenuOptions } from './hooks';

export function MovementByScreenNewLayout() {
  const {
    movementsMenuPermissionsState,
    refreshMovementsMenuPermissionsState,
    hasFilter,
  } = useMovementMenuOptions();

  const { isError, isLoading } = movementsMenuPermissionsState;

  if (isLoading) {
    return (
      <Loading
        padding={8}
        message={
          <>
            Estamos carregando as informações. <br /> Em breve, tudo estará
            pronto para você
          </>
        }
      />
    );
  }

  if (isError) {
    return (
      <ErrorLoadingPage onReloadClick={refreshMovementsMenuPermissionsState} />
    );
  }

  if (hasFilter) {
    return <FilteredServices />;
  }

  return <GroupedServices />;
}
